module.exports = __webpack_public_path__ + "img/227-senegal.4362aabd.svg";